const getStudioListResponse = (response) => {
  return response?.data?.studios?.map((studio) => {
    return {
      label: `${studio?.room}, ${studio?.name}`,
      value: studio.id,
      rawData: studio,
    };
  });
};

export default getStudioListResponse;
